import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Anchor, Type } from "@ebscois/react-component-library";

const QuickAnswerLink = ({ linkUrl }) => {
  return (
    <Fragment>
      <Type element="em">See corresponding </Type>
      <Anchor as={Link} to={linkUrl} fontWeight="semibold">
        Quick Answers
      </Anchor>
    </Fragment>
  );
};

QuickAnswerLink.prototypes = {
  linkUrl: PropTypes.string.isRequired,
};

QuickAnswerLink.displayName = "QuickAnswerLink";

export default QuickAnswerLink;
